import * as React from 'react';
import { styled } from '../theme-provider';
import { Text, TokenTextAppearance, TokenTextColor, TextTag } from '../text';
import { THUMB_SIZE } from './thumb';
const StyledMarks = styled.div.withConfig({ displayName: "StyledMarks", componentId: "sc-s820dx" }) `justify-content:space-between;display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-start;min-height:${(props) => props.theme.size.static300};`;
const StyledMark = styled.div.attrs(({ xFraction, railWidth }) => {
    // the rail has padding of one thumb to its sides
    const railEdgeOffset = THUMB_SIZE;
    return {
        style: {
            '--startPercent': `${xFraction * 100}%`,
            '--railWidthStart': `${railWidth * xFraction + railEdgeOffset}px`,
            '--railWidthEnd': `${railWidth * (1 - xFraction) + railEdgeOffset}px`,
        },
    };
}).withConfig({ displayName: "StyledMark", componentId: "sc-1q3erep" }) `position:relative;max-width:0;overflow:visible;${(props) => props.theme.direction === 'rtl'
    ? 'right: var(--startPercent);'
    : 'left: var(--startPercent);'} padding-top:${(props) => props.highlight ? props.theme.size.static450 : props.theme.size.static200};color:${(props) => props.theme.colors.content.primary};::before{content:'';display:${(props) => (props.highlight ? 'initial' : 'none')};position:absolute;top:${(props) => props.theme.size.static250};width:0;height:${(props) => props.highlight
    ? props.theme.size.static300
    : props.theme.size.static150};border-left:${(props) => props.theme.size.border.light} solid ${(props) => props.theme.colors.content.primary};}> *{display:${(props) => (props.hideMinMax ? 'none' : 'inline-block')};position:relative;white-space:nowrap;transform:translateX(\n\t\t\tcalc(\n\t\t\t\t${({ theme }) => (theme.direction === 'rtl' ? -1 : 1)} *\n\t\t\t\t\tclamp(-1 * var(--railWidthStart), -50%, -100% + var(--railWidthEnd))\n\t\t\t)\n\t\t);}`;
export const Marks = ({ getValueText, highlights, railWidth, min, max, hideMinMax, }) => {
    /** calculate "percentage" as fraction of 1 */
    const fr = React.useCallback((value) => (value - min) / (max - min), [min, max]);
    /** Could be adapted in the future to include a small stroke for every step,
     * or similar, if that feature is wished for */
    const effectiveMarks = React.useMemo(() => [
        // Array will get deduplicated starting at the lowest index
        // That means the order we add the marks is the order of precedence
        // (i.e., a highlight at min, will make the min label disappear)
        ...highlights.map((highlight) => (Object.assign(Object.assign({}, highlight), { highlight: true }))),
        {
            value: min,
            label: getValueText(min),
        },
        {
            value: max,
            label: getValueText(max),
        },
    ]
        .filter((m) => m.label)
        .filter((m1, index, all) => all.findIndex((m2) => m2.value === m1.value) === index)
        .sort((a, b) => a.value - b.value), [getValueText, highlights, max, min]);
    return (React.createElement(StyledMarks, null, effectiveMarks.map(({ value, label, highlight }) => (React.createElement(StyledMark, { key: value, xFraction: fr(value), highlight: highlight, railWidth: railWidth, hideMinMax: hideMinMax }, label && (React.createElement(Text, { tag: TextTag.span, appearance: TokenTextAppearance.copy100, staticSize: true, color: TokenTextColor.inherit }, label)))))));
};
